import { render, staticRenderFns } from "./ProjectGuide.vue?vue&type=template&id=b263e154&scoped=true&"
import script from "./ProjectGuide.vue?vue&type=script&lang=js&"
export * from "./ProjectGuide.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGuide.vue?vue&type=style&index=0&id=b263e154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b263e154",
  null
  
)

export default component.exports